import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, TextField, useTheme } from '@mui/material';
import useAccountInformationStyles from './useAccountInformationStyles';
import { useSelector } from 'react-redux';
const AccountInformation = (props) => {
    const theme = useTheme();
    const { accountInformationButtonStyles, accountInformationSectionStyles, textFieldStyles } = useAccountInformationStyles();
    const { user } = useSelector((state) => state.authSlice);
    const handleEditAccountInfo = () => { };
    const [formData, setFormData] = useState([
        {
            id: 'first-name',
            label: 'First Name',
            value: user?.name?.split(" ")[0],
            type: 'text'
        },
        {
            id: 'last-name',
            label: 'Last Name',
            value: user?.name?.split(" ")[1],
            type: 'text'
        },
        {
            id: 'email',
            label: 'Email Address',
            value: user?.email,
            type: 'email'
        }
    ]);
    return (_jsx(Box, { className: 'section-account-information', sx: accountInformationSectionStyles, children: _jsx("form", { className: 'account-info-form', children: formData.map((item) => (_jsx(TextField, { id: item.id, label: item.label, value: item.value, type: item.type, size: 'small', variant: 'outlined', sx: textFieldStyles }))) }) }));
};
export default AccountInformation;
